import React, { useState, useEffect, useContext, useRef } from "react";
import api from "../../api/axiosConfig";
import { MultiSelect } from "react-multi-select-component";
import { useRolePermissions } from "../Settings/RoleContext";
import { useAuth } from "../Authentication/AuthContext";
import socket from "../../socket";
import { ProjectContext } from "../../App";
import "./../../styles/projects/Todo.css";
import DatePicker from "react-datepicker";
import format from "date-fns/format";
import { ToastContainer, toast } from "react-toastify";
import TodoHistory from "./TodoHistory";
import { LuCircleChevronDown } from "react-icons/lu";
import TodoFilter from "./TodoFilter";
import { IoMdClose } from "react-icons/io";
import { AiOutlineSend } from "react-icons/ai";

function ToDoList() {
  const { hasPermission } = useRolePermissions();
  const { isNavBarOpen } = useContext(ProjectContext);
  const { userDetails } = useAuth();
  const [todoDueDate, setTodoDueDate] = useState(null);
  const [todoEdit, setTodoEdit] = useState(false);
  const [todoToEdit, setTodoToEdit] = useState(false);
  const [createToDoDial, setCreateToDoDial] = useState(false);
  const [projects, setProjects] = useState([]);
  const [activeTab, setActiveTab] = useState("open");
  const [selectedProject, setSelectedProject] = useState(null);
  const [phases, setPhases] = useState([]);
  const [selectedPhase, setSelectedPhase] = useState([]);
  const [users, setUsers] = useState([]);
  const [projectManager, setProjectManager] = useState([]);
  const [estimates, setEstimates] = useState([]);
  const [selectedEstimate, setSelectedEstimate] = useState("");
  const [projectUsers, setProjectUsers] = useState([]);
  const [isOverallAssigned, setIsOverallAssigned] = useState(false);
  const [isOverallCC, setIsOverallCC] = useState(false);
  const [projectCustomers, setProjectCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [assignedTo, setAssignedTo] = useState([]);
  const [reportedTo, setReportedTo] = useState([]);
  const [ccTo, setCCTo] = useState([]);
  const [comments, setComments] = useState("");
  const [notification, setNotification] = useState(1);
  const [subject, setSubject] = useState("");
  const [priority, setPriority] = useState("Low");
  const [toDoList, setToDoList] = useState([]);
  const [filteredToDoList, setFilteredToDoList] = useState([]);
  const [message, setMessage] = useState("");
  const [filters, setFilters] = useState({
    user: "",
    userFilterType: "contains",
    selectedProjects: "",
    ProjectFilterType: "contains", // exact or contains
    date: "",
    fromDate: "",
    toDate: "",
    dateFilterType: "specified", // specified or range
  });
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);
  const dropdownRef = useRef(null);
  const historyRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProjectName, setSelectedProjectName] = useState("");
  const [selectedProjectCustomer, setSelectedProjectCustomer] = useState("");
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [expandedTicket, setExpandedTicket] = useState(null);
  const [tsCategory, setTsCategory] = useState("Project");

  useEffect(() => {
    const stored = localStorage.getItem("expandedTicket");
    const history = localStorage.getItem("expandedTicketHistory");
    if (stored) {
      setExpandedTicket(Number(stored)); // convert to number if ID is numeric
      setTodoChatOpen(history);
    }
  }, []);

  const [selectedTodo, setSelectedTodo] = useState("");
  const [selectedTodoStatus, setSelectedTodoStatus] = useState("");
  const [selectedTodoName, setSelectedTodoName] = useState("");
  const [todoChatopen, setTodoChatOpen] = useState(false);
  const [forward, setForward] = useState("");
  const [forwardTo, setForwardTo] = useState("");
  const [fetchHistory, setFetchHistory] = useState(false);
  const toggleExpand = (ticketId) => {
    const newExpanded = expandedTicket === ticketId ? null : ticketId;
    const expandHistory = newExpanded !== null ? true : false;
    setExpandedTicket(newExpanded);
    setTodoChatOpen(expandHistory);
    if (newExpanded === null) {
      // If the ticket is collapsed, remove it from localStorage
      localStorage.removeItem("expandedTicket");
      localStorage.removeItem("expandedTicketHistory");
    } else {
      // If the ticket is expanded, save it to localStorage
      localStorage.setItem("expandedTicket", newExpanded);
      localStorage.setItem("expandedTicketHistory", expandHistory);
    }
  };
  useEffect(() => {
    if (selectedProject) {
      const project = projects.find((p) => p.id === Number(selectedProject));
      setSelectedProjectName(`${project.projectno}-${project.name}`);
      setSelectedProjectCustomer(project.customer_id);
    }
  }, [selectedProject, projects]);
  const getOptions = (isOverall) => {
    let userList = [];

    if (tsCategory === "Project") {
      userList = isOverall ? users : projectUsers;
    } else if (tsCategory === "General") {
      userList = users;
    } else if (tsCategory === "Estimate") {
      userList = isOverall ? users : projectManager;
    }

    const baseOptions = (userList || [])
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((user) => ({
        label: user.name || "Unnamed",
        value: String(user.id),
      }));

    const overallOption =
      tsCategory === "Project" || tsCategory === "Estimate"
        ? [{ label: "Overall Users", value: "overall-users" }]
        : [];

    return [...baseOptions, ...overallOption];
  };

  useEffect(() => {
    socket.on("new todo added", async ({ id }) => {
      const ID = Number(id);
      setTimeout(async () => {
        try {
          const res = await api.get(`/api/todolists/todo/${ID}`);
          const newTodo = res.data;
          if (!newTodo) {
            console.error("Error: No new todo found for ID", ID);
            return;
          }
          const extractUserIds = (arr) => {
            if (!Array.isArray(arr)) return [];
            return arr.map((user) => parseInt(user.id));
          };
          const assignedIds = extractUserIds(newTodo.assigned_users);
          const ccIds = extractUserIds(newTodo.cc_users);
          const userId = userDetails.id;
          const isUserInvolved =
            assignedIds.includes(userId) ||
            ccIds.includes(userId) ||
            Number(newTodo.forwarded_to_id) === userId;
          if (
            isUserInvolved ||
            userDetails.role_name === "Administrator" ||
            userDetails.role_name === "Super Admin"
          ) {
            setToDoList((prev) => [...prev, newTodo]);
          }
        } catch (error) {
          console.error("Error fetching new todo:", error);
        }
      }, 500); // Delay for 500ms (adjust as needed)
    });

    socket.on("todo updated", (id, field) => {
      setToDoList((prev) =>
        prev.map((t) => (t.id === Number(id) ? { ...t, ...field } : t))
      );
      setFetchHistory(true);
    });
    socket.on("new_message", (newMessage) => {
      setFetchHistory(true);
      setSelectedTodo(newMessage.todolist_id);
    });
    return () => {
      socket.off("todo updated");
      socket.off("new todo added");
    };
  }, [socket, setToDoList]);

  // Fetch Active Projects
  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/api/projectlistdata`);
        const userRes = await api.get("/api/users");
        const activeProjects = res.data.filter(
          (project) => project.activestatus === 1
        );
        const estimateRes = await api.get(`/api/estimates-timesheet`);
        setEstimates(estimateRes.data);
        setUsers(userRes.data);
        setProjectManager(
          userRes.data.filter((u) => u.role_name === "Project_Manager")
        );
        setProjects(activeProjects);
      } catch (error) {
        setError(error);
        console.error("Error fetching project data:", error.message || error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
    // Fetch To-Do list when component mounts
  }, []);

  // Fetch To-Do List with Assigned and Reported Users
  const fetchToDoList = async () => {
    try {
      const endpoint =
        userDetails.role_name === "Administrator" ||
        userDetails.role_name === "Super Admin"
          ? "/api/todolists"
          : `/api/todolists/${userDetails.id}`;

      const res = await api.get(endpoint);

      const data = res.data; // <-- No need to re-map or parse anything

      const filteredData = data.filter((t) =>
        activeTab === "open"
          ? t.status === "open" || t.status === "reopen"
          : t.status !== "open" && t.status !== "reopen"
      );

      setToDoList(filteredData);
    } catch (error) {
      console.error("Error fetching to-do lists:", error);
      setError(error);
    }
  };

  useEffect(() => {
    fetchToDoList();
  }, [activeTab]); // only runs when tab changes

  // Fetch Users when a Project is Selected
  useEffect(() => {
    const fetchData = async () => {
      if (!selectedProject || !selectedProjectCustomer) return;

      setError(null);

      try {
        const [userRes, customerRes, phaseRes] = await Promise.all([
          api.get(`/api/projects/${selectedProject}/users`),
          api.get(`/api/customers/${selectedProjectCustomer}/contacts`),
          api.get(`/api/project/${selectedProject}/phases`),
        ]);
        setPhases(phaseRes.data || []);
        setProjectUsers(userRes.data || []);
        setProjectCustomers(customerRes.data.contacts || []);
      } catch (error) {
        setError(error);
        console.error("Error fetching data:", error.message || error);
      }
    };

    fetchData();
  }, [selectedProject, selectedProjectCustomer]);

  useEffect(() => {
    if (selectedEstimate) {
      const selectedEstimateCustomer = estimates.find(
        (e) => e.id === Number(selectedEstimate)
      );
      setProjectCustomers([
        {
          contact_name: selectedEstimateCustomer.contact_name,
          contact_id: selectedEstimateCustomer.contact_id,
        },
      ]);
    }
  }, [selectedEstimate]);

  const handleSearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(e.target.value);
    setSelectedProjectName("");

    const filtered = projects.filter((project) => {
      const name = project.name || ""; // Fallback to an empty string
      const projectno = project.projectno || ""; // Fallback to an empty string
      const displayName = project.displayName || ""; // Fallback to an empty string

      return (
        name.toLowerCase().includes(searchValue) ||
        projectno.toLowerCase().includes(searchValue) ||
        displayName.toLowerCase().includes(searchValue)
      );
    });

    setFilteredProjects(filtered);
    setShowDropdown(true); // Show the dropdown when the user types
  };
  // Determine border color based on priority
  const getBorderColor = (p) => {
    switch (p) {
      case "High":
        return "#FF0000"; // Red for high priority
      case "Medium":
        return "#FFA500"; // Orange for medium priority
      case "Low":
        return "#008000"; // Blue for low priority
      default:
        return "#007bff"; // Default to blue if something goes wrong
    }
  };
  const handleFocus = () => {
    setSearchTerm(""); // Reset the search term to show all projects
    setFilteredProjects(projects); // Show all projects when focusing on the input
    setShowDropdown(true); // Show the dropdown
  };

  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown and profile
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) //&&
      // profileRef.current &&  !profileRef.current.contains(event.target)
    ) {
      setShowDropdown(false); // Close the dropdown
    }
    if (
      historyRef.current &&
      !historyRef.current.contains(event.target) //&&
      // profileRef.current &&  !profileRef.current.contains(event.target)
    ) {
      setTodoChatOpen(false); // Close the dropdown
    }
  };

  // Add event listener for clicks outside the component
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle Project Selection
  const handleProjectChange = (e) => {
    setSearchTerm("");
    setShowDropdown(false);
    setIsOverallAssigned(false);
    setIsOverallCC(false);
    setAssignedTo([]);
    setCCTo([]);
    setReportedTo([]);
    setSelectedProject(e.target.value); // Sets selected project
  };

  // Add New To-Do List
  const handleAddToDoList = async () => {
    const newToDo = {
      project: selectedProject,
      phase: Number(selectedPhase),
      date: new Date(),
      duedate: todoDueDate,
      subject,
      priority,
      comments,
      notification,
      assignedTo,
      reportedTo,
      ccTo,
      created_by: userDetails.id,
      selectedEstimate,
      tsCategory,
    };
    const showError = () => {
      toast.error("Fill required fields", {
        position: "bottom-center",
        autoClose: 2000,
      });
    };

    const isEmpty = (value) =>
      !value || (Array.isArray(value) && value.length === 0);

    let missingFields = false;

    if (tsCategory === "Project") {
      missingFields =
        isEmpty(selectedProject) ||
        isEmpty(selectedPhase) ||
        isEmpty(assignedTo) ||
        isEmpty(ccTo) ||
        isEmpty(reportedTo) ||
        isEmpty(subject) ||
        isEmpty(comments);
    } else if (tsCategory === "Estimate") {
      missingFields =
        isEmpty(selectedEstimate) ||
        isEmpty(assignedTo) ||
        isEmpty(ccTo) ||
        isEmpty(reportedTo) ||
        isEmpty(subject) ||
        isEmpty(comments);
    } else {
      missingFields =
        isEmpty(assignedTo) ||
        isEmpty(ccTo) ||
        isEmpty(reportedTo) ||
        isEmpty(subject) ||
        isEmpty(comments);
    }

    if (missingFields) {
      showError();
      return;
    }

    try {
      await api.post("/api/todolists", newToDo);
      alert("To-Do List created successfully!");
      setCreateToDoDial(false);
      setComments("");
      setAssignedTo([]);
      setReportedTo([]);
      setPriority("Low");
      setTodoDueDate(null);
      setSelectedProject("");
      setSelectedProjectName("");
      setSubject("");
      setCCTo([]);
      setSelectedPhase([]);
      // fetchToDoList();
    } catch (error) {
      console.error("Error adding to-do list:", error);
      alert("Failed to create to-do list.");
    }
  };

  const handleEditTodoList = async () => {
    const isEmpty = (value) =>
      !value || (Array.isArray(value) && value.length === 0);
    const showError = () => {
      toast.error("Fill required fields", {
        position: "bottom-center",
        autoClose: 2000,
      });
    };

    let missingFields = false;

    if (tsCategory === "Project") {
      missingFields =
        isEmpty(selectedProject) ||
        isEmpty(selectedPhase) ||
        isEmpty(assignedTo) ||
        isEmpty(ccTo) ||
        isEmpty(reportedTo) ||
        isEmpty(subject) ||
        isEmpty(comments);
    } else if (tsCategory === "Estimate") {
      missingFields =
        isEmpty(selectedEstimate) ||
        isEmpty(assignedTo) ||
        isEmpty(ccTo) ||
        isEmpty(reportedTo) ||
        isEmpty(subject) ||
        isEmpty(comments);
    } else {
      missingFields =
        isEmpty(assignedTo) ||
        isEmpty(ccTo) ||
        isEmpty(reportedTo) ||
        isEmpty(subject) ||
        isEmpty(comments);
    }

    if (missingFields) {
      showError();
      return;
    }

    const newToDo = {
      id: todoToEdit,
      tsCategory, // ✅ Required by backend
      project: tsCategory === "Project" ? selectedProject : null,
      phase: tsCategory === "Project" ? Number(selectedPhase) : 0,
      estimate: tsCategory === "Estimate" ? selectedEstimate : null,
      duedate: todoDueDate,
      subject,
      priority,
      comments,
      assignedTo,
      reportedTo,
      ccTo,
      notification,
    };

    try {
      await api.put("/api/todolists", newToDo);
      toast.success("To-Do List updated successfully!", {
        position: "bottom-center",
        autoClose: 2000,
      });
      setCreateToDoDial(false);
      setComments("");
      setAssignedTo([]);
      setReportedTo([]);
      setCCTo([]);
      setPriority("Low");
      setTodoDueDate(null);
      setSelectedProject("");
      setSelectedEstimate("");
      setSelectedPhase("");
      setSelectedProjectName("");
      fetchToDoList();
    } catch (error) {
      console.error("Error updating to-do list:", error);
      toast.error("Failed to update to-do list.", {
        position: "bottom-center",
        autoClose: 2000,
      });
    } finally {
      setTodoEdit(false);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      await api.put(`/api/todolists/${id}/status`, {
        status: newStatus,
        userId: userDetails.id,
      });
      setToDoList((prevList) =>
        prevList.map((todo) =>
          todo.id === id ? { ...todo, status: newStatus } : todo
        )
      );
      fetchToDoList();
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update status.");
    }
  };
  const handleTodoStatus = async (newStatus, id) => {
    try {
      await api.put(`/api/accept/${id}`, {
        accepted: newStatus,
        accepted_by: userDetails.id,
      });
      setToDoList((prevList) =>
        prevList.map((todo) =>
          todo.id === id ? { ...todo, accepted: newStatus } : todo
        )
      );
      fetchToDoList();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  const handleForwardStatus = async (
    newStatus,
    forward_by_id,
    forward_to_id,
    id
  ) => {
    try {
      await api.put(`/api/forward/${id}`, {
        forward: newStatus,
        forward_to: forward_to_id,
        forward_by: forward_by_id, // This is forwarded_by_id in your DB
      });

      setToDoList((prevList) =>
        prevList.map((todo) =>
          todo.id === id ? { ...todo, forward: newStatus } : todo
        )
      );
      // setForward("");
      fetchToDoList();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handlePriorityChange = (event) => {
    setPriority(event.target.value);
  };

  const handleEditTodo = (todo) => {
    setTsCategory(todo.category);
    setNotification(todo.notification);
    setTodoToEdit(todo.id);
    setTodoEdit(true);
    setTodoDueDate(todo.due_date);
    setSelectedProjectName(todo.project_name);
    setSelectedProject(todo.project);
    setSelectedEstimate(todo.estimate);
    setSelectedPhase(todo.phase);
    setSubject(todo.subject);
    setPriority(todo.priority);
    // Extract only IDs for MultiSelect
    setReportedTo(
      todo.reported_users ? todo.reported_users.map((user) => user.id) : []
    );
    setAssignedTo(
      todo.assigned_users ? todo.assigned_users.map((user) => user.id) : []
    );
    setCCTo(todo.cc_users ? todo.cc_users.map((user) => user.id) : []);
    setComments(todo.comments);
  };
  useEffect(() => {
    // Check each filter individually to determine its active status
    const isUserFilterActive = filters.user && filters.user.value;
    const isDateFilterActive = filters.date;
    const isFromDateFilterActive = filters.fromDate;
    const isToDateFilterActive = filters.toDate;

    // Determine if any filter is active
    const hasActiveFilters =
      isUserFilterActive ||
      isDateFilterActive ||
      isFromDateFilterActive ||
      isToDateFilterActive;
    setIsFilterActive(hasActiveFilters);
    setClearFilter(false);
  }, [filters]);

  useEffect(() => {
    const {
      fromDate,
      toDate,
      user,
      todoDueDate,
      selectedProjects,
      selectedPhase,
    } = filters;

    let filtered = [...toDoList];

    // ✅ DEBUG Dates
    if (fromDate && toDate) {
      const start = new Date(fromDate);
      const end = new Date(toDate);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);

      filtered = filtered.filter((todo) => {
        const todoDate = new Date(todo.date).getTime();
        const isInRange = todoDate >= start && todoDate <= end;
        return isInRange;
      });
    }

    // ✅ DEBUG Due Date filter
    if (todoDueDate) {
      const due = new Date(todoDueDate);
      due.setHours(0, 0, 0, 0);

      filtered = filtered.filter((todo) => {
        const dueDate = new Date(todo.due_date);
        dueDate.setHours(0, 0, 0, 0);
        const match = dueDate.getTime() === due.getTime();
        return match;
      });
    }

    // ✅ DEBUG User filter
    if (user?.value?.length) {
      const userId = user.value[0].toString();
      const isNot = user.condition === "not";

      filtered = filtered.filter((todo) => {
        const ccMatch = todo.cc_users?.some((u) => u.id === userId);
        const assignedMatch = todo.assigned_users?.some((u) => u.id === userId);
        const forwardedToMatch = todo.forwarded_to_id === userId;
        const forwardedByMatch = todo.forwarded_by_id === userId;

        const match =
          ccMatch || assignedMatch || forwardedToMatch || forwardedByMatch;

        return isNot ? !match : match;
      });
    }

    // ✅ DEBUG Project Filter
    if (selectedProjects?.value?.length) {
      const selectedProjectNames = selectedProjects.value;
      const isNot = selectedProjects.condition === "not";
      const isContains = filters.ProjectFilterType === "contains";

      filtered = filtered.filter((todo) => {
        let match = false;

        if (isContains) {
          match = selectedProjectNames.some((proj) =>
            todo.project_name?.toLowerCase().includes(proj.toLowerCase())
          );
        } else {
          match = selectedProjectNames.includes(todo.project_name);
        }
        return isNot ? !match : match;
      });
    }

    // ✅ DEBUG Phase Filter
    if (selectedPhase?.value?.length) {
      const selectedPhaseNames = selectedPhase.value;
      const isNot = selectedPhase.condition === "not";
      const isContains = filters.ProjectFilterType === "contains";

      filtered = filtered.filter((todo) => {
        let match = false;

        if (isContains) {
          match = selectedPhaseNames.some((phase) =>
            todo.phase_name?.toLowerCase().includes(phase.toLowerCase())
          );
        } else {
          match = selectedPhaseNames.includes(todo.phase_name);
        }
        return isNot ? !match : match;
      });
    }
    setFilteredToDoList(filtered);
  }, [toDoList, filters]);

  const handleClearFilters = () => {
    setFilters({
      user: { value: "", condition: "" },
      userFilterType: "contains",
      date: "",
      fromDate: "",
      toDate: "",
      dateFilterType: "range",
      selectedProjects: { value: "", condition: "" },
    });

    const keysToRemove = [
      "tselectedUsers",
      "tselectedProjects",
      "tphases",
      "tselectedPhase",
      "tlogUserCondition",
      "tprojectCondition",
      "tphaseCondition",
    ];
    fetchToDoList();
    keysToRemove.forEach((key) => {
      localStorage.removeItem(key);
    });
    setIsFilterActive(false);
    setClearFilter(true);
  };

  const handleFilterChange = (newFilters) => {
    const updatedFilters = { ...filters, ...newFilters };

    setFilters(updatedFilters);
  };

  const sendMessage = async () => {
    if (message.trim() === "") return;
    try {
      const response = await api.post(`/api/todolist/${selectedTodo}/chat`, {
        user_id: userDetails.id,
        message,
      });
      if (response.data.success) {
        setMessage("");
        const updated = await api.get(`/api/todolists/${selectedTodo}/history`);
        // const grouped = groupForwardedStatuses(updated.data.reverse());
        // setHistory(grouped);
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };
  const tabCount = hasPermission("estimates", "create") ? 3 : 2;

  const sliderLeft = () => {
    if (tsCategory === "Project") return "0%";
    if (tsCategory === "General") return tabCount === 3 ? "33.33%" : "50%";
    return tabCount === 3 ? "66.66%" : "100%";
  };

  const sliderWidth = () => 100 / tabCount + "%";
  const changeTsCategory = (c) => {
    setTsCategory(c);
    setSelectedEstimate("");
    setAssignedTo([]);
    setCCTo([]);
    setReportedTo([]);
    setComments("");
    setSelectedProject("");
    setSelectedProjectName("");
    setTodoDueDate("");
    setTodoEdit(false);
    setIsOverallAssigned(false);
    setIsOverallCC(false);
    setSubject("");
  };

  if (loading)
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <span className="loading-animation">LOADING...</span>
      </div>
    );

  return (
    <>
      <div className="todo-date-range">
        <TodoFilter refresh={handleFilterChange} clearFilter={clearFilter} />
      </div>
      <div className={isNavBarOpen ? "todo-container" : "todo-container-close"}>
        {isFilterActive && (
          <button
            onClick={handleClearFilters}
            className="clear-filter-btn clear-btn-todo"
          >
            Clear
          </button>
        )}
        <ToastContainer />
        {hasPermission("todolist", "create") && (
          <button
            className="add-todo-list-btn"
            onClick={() => setCreateToDoDial(true)}
          >
            Add To-Do List
          </button>
        )}
        <div
          className={
            isNavBarOpen
              ? "todo-active-tab-container"
              : "todo-active-tab-container-close"
          }
        >
          <div
            className="tab-slider"
            style={{ left: activeTab === "open" ? "5px" : "calc(50% + 5px)" }}
          ></div>
          <button
            className={
              activeTab === "open" ? "active-tab-btn" : "normal-tab-btn"
            }
            onClick={() => {
              setActiveTab("open");
              setExpandedTicket(null);
            }}
          >
            Active
          </button>
          <button
            className={
              activeTab === "close" ? "active-tab-btn" : "normal-tab-btn"
            }
            onClick={() => {
              setActiveTab("close");
              setExpandedTicket(null);
            }}
          >
            Closed
          </button>
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>Error fetching data.</p>
        ) : (
          <div
            className={
              isNavBarOpen ? "ticket-container" : "ticket-container-close"
            }
          >
            {filteredToDoList
              .sort((a, b) => b.id - a.id)
              .map((todo) => {
                const extractUserIds = (arr) => {
                  if (!Array.isArray(arr)) return [];
                  return arr.map((user) => parseInt(user.id));
                };
                const assignedIds = extractUserIds(todo.assigned_users);
                const ccIds = extractUserIds(todo.cc_users);
                const reportedToId = extractUserIds(todo.reported_users);
                const userId = userDetails.id;
                const isUserInvolved =
                  assignedIds.includes(userId) ||
                  ccIds.includes(userId) ||
                  Number(todo.forwarded_to_id) === userId;
                const isUserReported = reportedToId.includes(userId);
                const isExpanded = expandedTicket === todo.id;
                return (
                  <div
                    ref={historyRef}
                    key={todo.id}
                    style={{
                      background: "white",
                      borderRadius: "8px",
                      boxShadow: "0 2px 9px rgba(0, 0, 0, 0.2)",
                      padding: "15px",
                      display: "flex",
                      flexDirection: "column",
                      borderLeft: `5px solid ${getBorderColor(todo.priority)}`,
                      position: "relative",
                      cursor: "pointer",
                      width: "60vw",
                    }}
                    className="ticket-card"
                  >
                    {/* Ticket Header - Always Visible */}
                    <div className="ticket-header">
                      <span className="ticket-number">
                        <span className="ticket-label">Ticket no.</span>
                        <span className="ticket-id">#{todo.id}</span>
                      </span>
                      <p className="todo-date">
                        <strong className="ticket-label">Due Date:</strong>
                        <span className="ticket-id">
                          {""}
                          {todo.due_date
                            ? format(new Date(todo.due_date), "dd-MM-yyyy")
                            : ""}
                        </span>
                      </p>{" "}
                      <p className="todo-project">
                        <strong className="ticket-label">
                          {todo.category === "Project"
                            ? "Project"
                            : todo.category === "Estimate"
                            ? "Estimate"
                            : "General"}
                        </strong>{" "}
                        <span className="ticket-id">
                          {todo.projectno && todo.project_name
                            ? `${todo.projectno} - ${todo.project_name}`
                            : todo.project_name || todo.projectno || ""}
                        </span>
                      </p>
                      <p
                        style={{
                          position: "absolute",
                          left: "39rem",
                          top: "0.9rem",
                        }}
                        className="todo-assignedto"
                      >
                        <strong className="ticket-label">Subject:</strong>
                        <span className="ticket-id"> {todo.subject}</span>
                      </p>
                      <div className="todo-edit-forward-su">
                        {forward === todo.id && (
                          <div className="forward-to-container-con">
                            <div className="forward-to-container">
                              <IoMdClose
                                onClick={() => setForward("")}
                                className="forwarded-to-close-icon"
                              />
                              <p className="select-user-para">Select User :</p>
                              <select
                                className="todo-forward-user"
                                onChange={(e) => setForwardTo(e.target.value)}
                                onBlur={(e) =>
                                  handleForwardStatus(
                                    "yes",
                                    userDetails.id,
                                    e.target.value,
                                    todo.id
                                  )
                                }
                                value={forwardTo}
                              >
                                <option value="" disabled>
                                  Select User
                                </option>{" "}
                                {users
                                  .sort((a, b) => a.name.localeCompare(b.name))
                                  .map((u) => (
                                    <option key={u.id} value={u.id}>
                                      {u.name}
                                    </option>
                                  ))}
                              </select>
                              <form
                                className="chat-input forward-to-container-chat"
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  sendMessage();
                                }}
                              >
                                <p>Comments :</p>
                                <input
                                  style={{ marginLeft: "12px" }}
                                  type="text"
                                  className="send-message-input"
                                  value={message}
                                  placeholder="Type a message(Max 200 characters)..."
                                  onChange={(e) => setMessage(e.target.value)}
                                  maxLength={200}
                                />
                                <button
                                  type="submit"
                                  style={{ border: "none", cursor: "pointer" }}
                                >
                                  <AiOutlineSend
                                    style={{ backgroundColor: "transparent" }}
                                  />
                                </button>
                              </form>
                            </div>
                          </div>
                        )}
                        {todo.forwarded === "yes" && activeTab !== "close" && (
                          <button className="accept-forwarded-btn">
                            FORWARDED
                          </button>
                        )}
                        {todo.accepted === "no" &&
                          todo.forwarded !== "yes" &&
                          activeTab !== "close" && (
                            <button className="accept-pending-btn">
                              PENDING
                            </button>
                          )}
                        {(todo.status === "closed" ||
                          todo.status === "withdrawn") && (
                          <button className="todo-btn-status">
                            {todo.status.toUpperCase()}
                          </button>
                        )}
                        <button
                          onClick={() => {
                            toggleExpand(todo.id);
                            // setTodoChatOpen((prev) => !prev);

                            setSelectedTodo(todo.id);
                            setSelectedTodoStatus(todo.status);
                            setSelectedTodoName(todo.id);
                            setForward("");
                          }}
                          className={`chevron-icon ${
                            isExpanded ? "expanded" : ""
                          }`}
                        >
                          <LuCircleChevronDown />
                        </button>
                      </div>
                    </div>
                    {/* Expanded Mode - Only Visible When Expanded */}
                    {isExpanded && (
                      <div className="ticket-details">
                        <div className="ticket-details-con-1">
                          <p className="exp-ticket-details-con">
                            <strong className="ticket-label">Category:</strong>
                            <span className="todo-more-details">
                              {" "}
                              {todo.category}
                            </span>
                          </p>
                          <p className="exp-ticket-details-con">
                            <strong className="ticket-label">Phase:</strong>
                            <span className="todo-more-details">
                              {todo.phase_no}-{todo.phase_name}
                            </span>
                          </p>
                          <p className="exp-ticket-details-con">
                            <strong className="ticket-label">Report to:</strong>
                            <span className="todo-more-details">
                              {""}
                              {Array.isArray(todo.reported_users)
                                ? todo.reported_users
                                    .map((user) => user.name)
                                    .join(", ")
                                : ""}
                            </span>
                          </p>
                          <p className="exp-ticket-details-con">
                            <strong className="ticket-label">
                              Assigned to:
                            </strong>
                            <span className="todo-more-details">
                              {""}
                              {Array.isArray(todo.assigned_users)
                                ? todo.assigned_users
                                    .map((user) => user.name)
                                    .join(", ")
                                : ""}
                            </span>
                          </p>
                          <p className="exp-ticket-details-con">
                            <strong className="ticket-label">Copy to:</strong>
                            <span className="todo-more-details">
                              {""}
                              {Array.isArray(todo.cc_users)
                                ? todo.cc_users
                                    .map((user) => user.name)
                                    .join(", ")
                                : ""}
                            </span>
                          </p>
                          <p className="exp-ticket-details-con">
                            <strong className="ticket-label">Priority:</strong>
                            <span className="todo-more-details">
                              {todo.priority}
                            </span>
                          </p>
                          <p className="exp-ticket-details-con">
                            <strong className="ticket-label">
                              Description:
                            </strong>
                            <span className="todo-comment-details">
                              {""}
                              {todo.comments || ""}
                            </span>
                          </p>
                        </div>
                        <div className="ticket-details-con-2">
                          {!isUserReported &&
                            todo.accepted === "yes" &&
                            todo.created_by === userDetails.id &&
                            todo.status === "resolved" && (
                              <button
                                style={{ right: "6rem" }}
                                className={`ticket-status ${todo.status.toLowerCase()}`}
                                onClick={() =>
                                  handleStatusChange(todo.id, "reopen")
                                }
                              >
                                Reopen
                              </button>
                            )}
                          {hasPermission("todolist", "create") &&
                            todo.accepted !== "yes" &&
                            todo.status !== "withdrawn" && (
                              <button
                                className="edit-todo-btn"
                                onClick={() => {
                                  handleEditTodo(todo);
                                }}
                              >
                                Edit
                              </button>
                            )}
                          {todo.forwarded === "no" &&
                            todo.accepted === "no" && (
                              <button
                                className="accept-forward-btn"
                                style={{ cursor: "pointer" }}
                                disabled={todo.forwarded === "yes"}
                                onClick={() => {
                                  setForward((prev) =>
                                    prev === todo.id ? null : todo.id
                                  ); // Toggle per-todo forward
                                }}
                              >
                                {todo.forwarded === "no"
                                  ? "Forward"
                                  : "Forwarded"}
                              </button>
                            )}{" "}
                          {isUserInvolved &&
                            todo.accepted === "no" &&
                            Number(todo.forwarded_by_id) !== userDetails.id && (
                              <button
                                className="accept-todo-btn"
                                style={{ cursor: "pointer" }}
                                disabled={todo.accepted === "yes"}
                                onClick={() => handleTodoStatus("yes", todo.id)}
                              >
                                {todo.accepted === "no" ? "Accept" : "Accepted"}
                              </button>
                            )}
                          {!isUserReported &&
                            todo.status !== "closed" &&
                            todo.status !== "withdrawn" &&
                            // ✅ Allow creator to withdraw
                            (todo.created_by === userDetails.id ||
                              // ✅ Allow others only if accepted
                              (todo.accepted === "yes" &&
                                todo.created_by !== userDetails.id)) && (
                              <button
                                className={`ticket-status ${todo.status.toLowerCase()}`}
                                onClick={() =>
                                  handleStatusChange(
                                    todo.id,
                                    todo.status === "open" ||
                                      todo.status === "reopen"
                                      ? todo.created_by === userDetails.id
                                        ? "withdrawn"
                                        : "resolved"
                                      : todo.status === "resolved" &&
                                        todo.created_by === userDetails.id
                                      ? "closed" // ✅ Only shown to creator
                                      : todo.status === "closed"
                                      ? "reopen"
                                      : "open"
                                  )
                                }
                                disabled={
                                  todo.status === "withdrawn" ||
                                  todo.status === "closed" ||
                                  (todo.status === "resolved" &&
                                    todo.created_by !== userDetails.id) ||
                                  (todo.status === "closed" &&
                                    todo.created_by !== userDetails.id)
                                }
                              >
                                {todo.status === "open" ||
                                todo.status === "reopen"
                                  ? todo.created_by === userDetails.id
                                    ? "Withdraw"
                                    : "Resolve"
                                  : todo.status === "resolved" &&
                                    todo.created_by === userDetails.id
                                  ? "Close"
                                  : todo.status === "closed" &&
                                    todo.created_by === userDetails.id
                                  ? "Reopen"
                                  : todo.status}
                              </button>
                            )}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        )}
        {(createToDoDial || todoEdit) && (
          <div className="add-todo-overlay-dial">
            <div className="add-todo-con">
              <div className="add-new-todo-header">
                <h3
                  style={{
                    backgroundColor: "transparent",
                    marginLeft: "19px",
                    marginTop: "5px",
                    fontSize: "15px",
                  }}
                >
                  {todoEdit ? "Edit Todo" : "Add To do"}
                </h3>
              </div>
              <div className="add-timesheet-category-con">
                <div
                  className="tab-slider-ts"
                  style={{
                    left: sliderLeft(),
                    width: sliderWidth(),
                  }}
                />
                <button
                  onClick={() => {
                    changeTsCategory("Project");
                  }}
                  className={
                    tsCategory === "Project"
                      ? "dial-active-btn active-tab-btn"
                      : "dial-normal-btn normal-tab-btn"
                  }
                >
                  Project
                </button>
                <button
                  onClick={() => {
                    changeTsCategory("General");
                  }}
                  className={
                    tsCategory === "General"
                      ? "dial-active-btn active-tab-btn"
                      : "dial-normal-btn normal-tab-btn"
                  }
                >
                  General
                </button>
                {hasPermission("estimates", "create") && (
                  <button
                    onClick={() => {
                      changeTsCategory("Estimate");
                    }}
                    className={
                      tsCategory === "Estimate"
                        ? "dial-active-btn active-tab-btn"
                        : "dial-normal-btn normal-tab-btn"
                    }
                  >
                    Estimate
                  </button>
                )}
              </div>
              <div className="todo-content-container">
                {tsCategory === "Project" && (
                  <>
                    <h3 className="todo-name">Project</h3>
                    <input
                      ref={dropdownRef}
                      className="todo-d-input"
                      placeholder="Search Projects"
                      value={searchTerm || selectedProjectName || ""}
                      onChange={handleSearchChange}
                      onFocus={handleFocus}
                      onMouseDown={() => handleClickOutside}
                      disabled={todoEdit}
                    />
                  </>
                )}
                {showDropdown &&
                  tsCategory === "Project" &&
                  (showDropdown && filteredProjects?.length > 0 ? (
                    <ul
                      style={{ zIndex: "50" }}
                      ref={dropdownRef}
                      className="todo-display-box"
                    >
                      {filteredProjects.map((project) => (
                        <li
                          key={project.id}
                          value={project.id}
                          onClick={(e) => handleProjectChange(e)}
                          onMouseDown={() => handleClickOutside}
                          className="project-dropdown-item"
                        >
                          {project.projectno}-{project.name}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>
                      No Projects available, Contact DC to add project for you.
                    </p>
                  ))}
                {selectedProject &&
                  tsCategory === "Project" &&
                  phases.phases?.length > 0 && (
                    <>
                      <h3 className="todo-name">Phase</h3>
                      <select
                        className="select-todo-proj"
                        value={selectedPhase}
                        onChange={(e) => setSelectedPhase(e.target.value)}
                      >
                        <option value="">Select Phase</option>
                        {phases.phases.map((phase) => (
                          <option key={phase.id} value={phase.id}>
                            {phase.phaseno}-{phase.title}
                          </option>
                        ))}
                      </select>
                    </>
                  )}
                {tsCategory === "Estimate" && (
                  <>
                    <h3 className="user-name">Estimate</h3>
                    <select
                      onChange={(e) => {
                        setSelectedEstimate(e.target.value);
                        setProjectCustomers([]);
                        setReportedTo([]);
                      }}
                      value={selectedEstimate || ""}
                      className="timesheet-input"
                    >
                      <option value="" disabled>
                        --Select Estimate--
                      </option>
                      {estimates.length > 0 ? (
                        estimates.map((est) => (
                          <option key={est.id} value={est.id}>
                            {`${est.estimationno}-${est.projectname}`}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>
                          There are no estimates available.
                        </option>
                      )}
                    </select>
                  </>
                )}
                <h3 className="todo-name">Assigned to</h3>
                <MultiSelect
                  className="todo-dropdown"
                  options={getOptions(isOverallAssigned)}
                  value={assignedTo
                    .map((id) => {
                      const source =
                        isOverallAssigned || tsCategory === "General"
                          ? users
                          : tsCategory === "Project"
                          ? projectUsers
                          : projectManager || [];
                      const user = source.find(
                        (u) => String(u.id) === String(id)
                      );
                      return user
                        ? { label: user.name, value: String(user.id) }
                        : null;
                    })
                    .filter(Boolean)}
                  onChange={(selected) => {
                    const includesOverall = selected.some(
                      (item) => item.value === "overall-users"
                    );

                    if (includesOverall) {
                      setIsOverallAssigned(true);
                    }

                    const actualUsers = selected.filter(
                      (item) => item.value !== "overall-users"
                    );

                    setAssignedTo(
                      actualUsers.map((item) => String(item.value))
                    );
                  }}
                  labelledBy="Select Users"
                />

                <h3 className="todo-name">Copy to</h3>
                <MultiSelect
                  className="todo-dropdown"
                  options={getOptions(isOverallCC)}
                  value={ccTo
                    .map((id) => {
                      const source =
                        isOverallCC || tsCategory === "General"
                          ? users
                          : tsCategory === "Project"
                          ? projectUsers
                          : projectManager || [];

                      const user = source.find(
                        (u) => String(u.id) === String(id)
                      );
                      return user
                        ? { label: user.name, value: String(user.id) }
                        : null;
                    })
                    .filter(Boolean)}
                  onChange={(selected) => {
                    const includesOverall = selected.some(
                      (item) => item.value === "overall-users"
                    );

                    if (includesOverall) {
                      setIsOverallCC(true);
                    }

                    const actualUsers = selected.filter(
                      (item) => item.value !== "overall-users"
                    );

                    setCCTo(actualUsers.map((item) => String(item.value)));
                  }}
                  labelledBy="Select Users"
                />

                <h3 className="todo-name">Report to</h3>
                <MultiSelect
                  className="todo-dropdown"
                  options={
                    tsCategory === "Project" || tsCategory === "Estimate"
                      ? projectCustomers.map((user) => ({
                          label: user.contact_name || "Unnamed",
                          value: String(user.contact_id), // Ensure value is a string
                        }))
                      : users.map((user) => ({
                          label: user.name || "Unnamed",
                          value: String(user.id), // Ensure value is a string
                        }))
                  }
                  value={reportedTo
                    .map((id) => {
                      const user =
                        tsCategory === "Project" || tsCategory === "Estimate"
                          ? projectCustomers.find(
                              (u) => String(u.contact_id) === String(id)
                            )
                          : users.find((u) => String(u.id) === String(id));
                      return user
                        ? {
                            label:
                              tsCategory === "Project" ||
                              tsCategory === "Estimate"
                                ? user.contact_name
                                : user.name,
                            value:
                              tsCategory === "Project" ||
                              tsCategory === "Estimate"
                                ? String(user.contact_id)
                                : String(user.id),
                          }
                        : null;
                    })
                    .filter(Boolean)}
                  onChange={(selected) =>
                    setReportedTo(selected.map((item) => String(item.value)))
                  }
                  labelledBy="Select Users"
                />
                <div className="due-priority-con">
                  <div>
                    <h3 className="todo-name">Due Date</h3>
                    <DatePicker
                      className="todo-p-input"
                      selected={todoDueDate}
                      onChange={(date) => setTodoDueDate(date)}
                      dateFormat="dd-MM-yyyy"
                      required
                    />
                  </div>
                  <div>
                    <h3 className="todo-name">Priority</h3>
                    <div className="radio-group">
                      <input
                        type="radio"
                        name="priority"
                        id="low"
                        value="Low"
                        checked={priority === "Low"}
                        onChange={handlePriorityChange}
                      />
                      <label htmlFor="low">Low</label>

                      <input
                        type="radio"
                        name="priority"
                        id="medium"
                        value="Medium"
                        checked={priority === "Medium"}
                        onChange={handlePriorityChange}
                      />
                      <label htmlFor="medium">Medium</label>

                      <input
                        type="radio"
                        name="priority"
                        id="high"
                        value="High"
                        checked={priority === "High"}
                        onChange={handlePriorityChange}
                      />
                      <label htmlFor="high">High</label>
                    </div>
                  </div>
                </div>
                <h3 className="todo-name">Subject</h3>
                <input
                  className="input-todo-sub"
                  value={subject}
                  maxLength={150}
                  onChange={(e) => setSubject(e.target.value)}
                />
                <h3 className="todo-name">Add Description</h3>
                <textarea
                  className="todo-des"
                  value={comments}
                  maxLength={200}
                  onChange={(e) => setComments(e.target.value)}
                  placeholder="Enter comments"
                />
                <div className="email-checkbox-container">
                  <input
                    type="checkbox"
                    id="email"
                    style={{ cursor: "pointer" }}
                    checked={notification === 1}
                    onChange={(e) => setNotification(e.target.checked ? 1 : 0)}
                  />
                  <label htmlFor="email" style={{ cursor: "pointer" }}>
                    Email notification
                  </label>
                </div>
              </div>
              <div className="todo-btn-container">
                <button
                  className="add-btn todo-add-btn"
                  onClick={todoEdit ? handleEditTodoList : handleAddToDoList}
                >
                  {todoEdit ? "Update" : "Add"}
                </button>
                <button
                  className="cancel-btn todo-cancel-btn"
                  onClick={() => {
                    setCreateToDoDial(false);
                    setTsCategory("Project");
                    setSelectedEstimate("");
                    setAssignedTo([]);
                    setCCTo([]);
                    setReportedTo([]);
                    setComments("");
                    setSelectedProject("");
                    setSelectedProjectName("");
                    setTodoDueDate("");
                    setTodoEdit(false);
                    setIsOverallAssigned(false);
                    setIsOverallCC(false);
                    setSubject("");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        {todoChatopen && (
          <div className="todo-chat-box" ref={historyRef}>
            <TodoHistory
              selectedTodoName={selectedTodoName}
              todoId={selectedTodo}
              fetchHistory={fetchHistory}
              setFetchHistory={setFetchHistory}
              userId={userDetails.id}
              status={selectedTodoStatus}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default ToDoList;
